import moment from "moment";
import useWindowSize from "../../../hooks/useWindowSize";
import {
  useFetchGalleryArticle,
  useFetchHighlightArticle,
  useFetchWhatNew,
} from "../../../networks";
import { Card, Text } from "../../atoms";
import EventCarousel from "../../atoms/EventCarousel";
import "moment/locale/id";
import TournamentCard from "../TournamentCard";
import { usePageContextFunction } from "../../../context/PageContext";
import analytics from "../../../utils/analytics";
const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/featured-images/`;

const Home = ({ city }) => {
  const { setOpenPopUp: toglePopUp } = usePageContextFunction();
  const { data: dataHighlightArticle } = useFetchHighlightArticle(city);
  const { data: dataGalleryArticle } = useFetchGalleryArticle(city);
  const { data: dataWhatsNewArticle } = useFetchWhatNew(city);
  const { size } = useWindowSize();
  const dataHighlight = dataHighlightArticle?.data?.data;
  const dataGalleryRaw = dataGalleryArticle?.data?.data ?? [];
  const dataWhatsNew = dataWhatsNewArticle?.data?.data ?? [];
  const mobileTableView = () => {
    return (size?.width || 0) <= 769;
  };
  const dataGallery = !mobileTableView()
    ? dataGalleryRaw.slice(0, 2)
    : dataGalleryRaw;
  const dataGallery2 = dataGalleryRaw?.length > 2 && dataGalleryRaw.slice(2, 4);

  return (
    <div className="">
      <div className="home-section">
        <div className="home-section__item">
          <Text
            className="home-section__title mb-24"
            size="large"
            weight="bold"
          >
            {"Keseruan Hari Ini"}
          </Text>
          <EventCarousel
            data={dataHighlight ?? []}
            className={"home-section___gallery"}
            toglePopUp={toglePopUp} //deprecated
          />
        </div>
        {mobileTableView() && (
          <div className="home-section__item ml-2vw">
            <TournamentCard city={city} />
          </div>
        )}
        <div className="home-section__item ml-2vw">
          <Text
            className="home-section__title mb-24"
            size="large"
            weight="bold"
          >
            {"Yang Terbaru dari Piala by.U"}
          </Text>
          {dataWhatsNew.map((val, i) => {
            return (
              <Card
                onClick={() => {
                  const payload = {
                    event: `yangTerbaruDariPiala_${
                      city ?? analytics.defaultCity
                    }`,
                    article_name: val?.title,
                    article_id: val?.id,
                  };
                  analytics.sendEvent(payload);
                  toglePopUp({ state: true, data: val });
                }}
                img={`${imgPath}${val?.key_visual}`}
                className={
                  i === 0
                    ? "home-section__whatsnew"
                    : "home-section__whatsnew mt-40"
                }
                desc={val?.subtitle}
                title={val?.title}
                tail={moment(val?.created_at).format("DD MMM YYYY")}
                imgClassName={"card-container__whatsnew-image"}
              />
            );
          })}
        </div>
      </div>
      <div className="home-section">
        <div className="home-section__item home-section__item__gallery-item">
          <Text
            className="home-section__title mb-24 "
            size="large"
            weight="bold"
          >
            {"Galeri Foto Piala By.U"}
          </Text>
          <div className="home-section___gallery__container-list">
            {dataGallery.map((val, i) => {
              const imgVisual = mobileTableView()
                ? val?.key_visual_mobile
                : val?.key_visual;
              return (
                <>
                  <Card
                    onClick={() => {
                      const payload = {
                        event: `galeriFotoPiala_${
                          city ?? analytics.defaultCity
                        }`,
                        menu_name: val?.title,
                      };
                      analytics.sendEvent(payload);
                      window.open(val?.drive_url, "_blank").focus();
                    }}
                    img={`${imgPath}${imgVisual}`}
                    className={
                      i > 0
                        ? "home-section___gallery ml-40"
                        : "home-section___gallery"
                    }
                    imgClassName={"home-section__gallery-thumbnail mb-8"}
                    innerClassName={"home-section__gallery-thumbnail__inner"}
                    title={val?.title}
                    tail={moment(val?.gallery_date).format("DD MMM YYYY")}
                    titleClassName="home-section__gallery-thumbnail__title"
                    tailClassName="home-section__gallery-thumbnail__tail"
                    verticalLayout
                  />
                </>
              );
            })}
          </div>
          {!mobileTableView() && dataGallery2?.length > 0 && (
            <div className="home-section___gallery__container-list mb-80">
              {dataGallery2.map((val, i) => {
                const imgVisual = mobileTableView()
                  ? val?.key_visual_mobile
                  : val?.key_visual;
                return (
                  <Card
                    onClick={() => {
                      const payload = {
                        event: `galeriFotoPiala_${
                          city ?? analytics.defaultCity
                        }`,
                        menu_name: val?.title,
                      };
                      analytics.sendEvent(payload);
                      window.open(val?.drive_url, "_blank").focus();
                    }}
                    img={`${imgPath}${imgVisual}`}
                    className={
                      i > 0
                        ? "home-section___gallery ml-40"
                        : "home-section___gallery"
                    }
                    imgClassName={"home-section__gallery-thumbnail mb-8"}
                    title={val?.title}
                    tail={moment(val?.gallery_date).format("DD MMM YYYY")}
                    titleClassName="home-section__gallery-thumbnail__title"
                    tailClassName="home-section__gallery-thumbnail__tail"
                    verticalLayout
                  />
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Home;
